import styled from "@emotion/styled";
import { Button, Paper, Typography } from "@mui/material";
import VendorHero from "components/VendorHero";
import { VendorThemeContext } from "contexts/vendorContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "router/paths";
import { breakpoints } from "styles/utils";

const StyledPaper = styled(Paper)`
  margin: 0px 16px;
  padding: 24px 12px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: ${breakpoints.large}) {
    flex-direction: row;
    gap: 48px;
    margin: 0px;
    padding: 48px;
  }
`;

function Home() {
  const { vendorTheme } = useContext(VendorThemeContext);

  const navigate = useNavigate();

  const handleInstallNow = () => {
    navigate(LOGIN);
  };

  return (
    <StyledPaper>
      <img
        src={vendorTheme?.bannerImage}
        alt="banner do provedor"
        style={{
          maxWidth: "100%",
          height: "auto",
          display: "block",
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          alignSelf: "center",
          flex: 1,
        }}
      >
        <VendorHero />
        <Typography variant="h1" gutterBottom>
          Garantia da melhor e mais premiada proteção do mundo
        </Typography>
        <Typography variant="h2">
          Junte-se a mais de 400 milhões de usuários protegidos pela Kaspersky.
        </Typography>
        <Button
          variant="contained"
          style={{
            backgroundColor: "#FC1C38",
            alignSelf: "center",
          }}
          onClick={handleInstallNow}
        >
          Instale Agora
        </Button>
        <Typography variant="caption" align="center">
          Windows® | macOS® | Android™ | iOS®
        </Typography>
      </div>
    </StyledPaper>
  );
}

export default Home;
